<div class="space-y-1.5">
  <div class="flex flex-wrap items-center gap-1.5">
    <span class="text-[11px] font-semibold text-slate-600 mr-1">From</span>
    <button *ngFor="let p of meta?.senderPresets" type="button"
            class="h-7 px-2.5 text-xs rounded-lg border transition-colors"
            [ngClass]="isPreset(p.email) ? 'bg-slate-900 border-slate-900 text-white' : 'bg-white border-slate-200 text-slate-600 hover:border-slate-400'"
            [title]="p.name" (click)="usePreset(p)">{{ p.email }}</button>
    <button type="button"
            class="h-7 px-2.5 text-xs rounded-lg border transition-colors"
            [ngClass]="isCustom || customOpen ? 'bg-slate-900 border-slate-900 text-white' : 'bg-white border-dashed border-slate-300 text-slate-500 hover:border-slate-400'"
            (click)="openCustom()" title="Any address on this domain">
      <i class="fa-solid fa-pen text-[9px] mr-1"></i>Custom
    </button>
  </div>

  <!-- Custom address: the local part only — the domain is fixed and authenticated. -->
  <div *ngIf="isCustom || customOpen" class="flex flex-wrap items-center gap-1.5">
    <span class="inline-flex items-stretch h-8 rounded-lg border border-slate-300 bg-white overflow-hidden">
      <input type="text" class="w-32 sm:w-40 px-2 text-xs text-slate-800 focus:outline-none" placeholder="news"
             maxlength="64" [ngModel]="localPart" (ngModelChange)="localPart = $event" aria-label="Address" />
      <span class="px-2 grid place-items-center text-xs text-slate-400 bg-slate-50 border-l border-slate-200">&#64;{{ domain }}</span>
    </span>
    <input type="text" class="ceo-input !h-8 !text-xs !w-auto flex-1 min-w-[140px]" maxlength="60"
           placeholder="Display name (e.g. Totalum News)"
           [(ngModel)]="message.fromName" (ngModelChange)="onFieldChange()" aria-label="Display name" />
  </div>

  <div class="flex flex-wrap items-center gap-1.5">
    <span class="text-[11px] font-semibold text-slate-600 mr-1">Replies to</span>
    <select class="ceo-input !h-7 !text-xs !w-auto" [(ngModel)]="message.replyToKey" (ngModelChange)="onFieldChange()" aria-label="Reply-to address">
      <option *ngFor="let o of meta?.replyToOptions" [value]="o.key">{{ o.label }}</option>
    </select>
    <span *ngIf="!compact" class="text-[10px] text-slate-400">Only these mailboxes can receive replies.</span>
  </div>
</div>
